<!--  -->
<template>
  <div class="add_box">
    <el-card>
      <div class="search_box">
        <div>
          <el-input
            v-model="objr.name"
            style="width:200px;margin-right:10px"
            placeholder="请输入名称"
          />
          <el-select
            v-model="objr.pitcher_type"
            style="width:250px; margin-right:10px"
            placeholder="投手类型"
            prop="description"
          >
            <el-option
              v-for="item in pitcherOptions"
              :key="item.value"
              :label="item.description"
              :value="item.value"
            />
          </el-select>
          <el-select
            v-model="objr.type"
            style="width:250px"
            placeholder="短剧类型"
            prop="description"
          >
            <el-option
              v-for="item in dramaOptions"
              :key="item.value"
              :label="item.description"
              :value="item.value"
            />
          </el-select>
          <el-button
            type="primary"
            style="margin-left:10px"
            icon="el-icon-search"
            @click="sraw"
          >搜索</el-button>
          <el-button
            type="info"
            icon="el-icon-refresh"
            @click="awered"
          >重置</el-button>
        </div>
        <div>
          <el-button
            type="success"
            icon="el-icon-upload2"
            @click="importbit"
          >导入</el-button>
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="addbit"
          >新增</el-button>
        </div>
      </div>

      <!-- <el-button type="primary" @click="awered">重置</el-button> -->
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%;margin-top:20px"
      >
        <el-table-column
          prop="pitcher_type_text"
          label="投手类型"
          width="120"
          align="center"
        />
        <el-table-column
          prop="type_text"
          label="短剧类型"
          width="120"
          align="center"
        />
        <el-table-column
          prop="name"
          label="名称"
          width="200"
          align="center"
        />
        <el-table-column
          prop="book_id"
          label="短剧id"
          width="200"
          align="center"
        />
        <el-table-column
          prop="image_url"
          label="图片"
          align="center"
          width="180"
        >
          <template scope="scope">
            <el-image
              style="width: 80px; height: 80px"
              :src="scope.row.thumb_uri"
              :preview-src-list="[scope.row.thumb_uri]"
              fit="cover"
            >
              <div
                slot="error"
                class="image-slot"
                style="line-height:80px"
              >
                <i class="el-icon-picture-outline" />
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="limit_date"
          label="截至时间"
          align="center"
        />
        <el-table-column
          align="center"
          prop="work_status"
          label="操作"
        >
          <!-- slot-scope="scope" -->
          <template slot-scope="scope">
            <el-button
              type="warning"
              size="mini"
              @click="edit(scope.row)"
            >编辑</el-button>
            <el-button
              type="danger"
              size="mini"
              @click="deleteItem(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        ref="paginationbox"
        :total="newtotalr"
        :page-sizes="[10]"
        @size-change="fetchPageSizer($event)"
        @current-change="fetchCurrentPager"
      />
    </el-card>
    <!-- 新增/编辑弹框 -->
    <el-dialog
      :title="adtype === 1 ? '新增' : '编辑'"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      width="35%"
    >
      <readingcreatedialog
        v-if="isDataReady"
        ref="readingcreateview"
        @updatawe="updatawe"
      />
    </el-dialog>
    <!-- 导入弹框 -->
    <el-dialog
      title="导入"
      :visible.sync="dialogVisibleImport"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      width="35%"
    >
      <readingimportdialog
        ref="readingimportview"
        @updatawe="updataweImport"
      />
    </el-dialog>
  </div>
</template>

<script>
import readingcreatedialog from './components/readingcreatedialog.vue'
import readingimportdialog from './components/readingimportdialog.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { changduplayletindex, weworkPhoneDelete, getDramaTypeList } from '@/api/providerAccountManagement/servicePorviderList.js'
export default {
  components: {
    readingcreatedialog,
    readingimportdialog,
    PaginationRight
  },
  data() {
    return {
      isDataReady: false,
      dialogVisible: false,
      dialogVisibleImport: false,
      objr: {
        page: 1,
        page_size: 10,
        name: null,
        type: null,
        pitcher_type: null
      },
      adtype: null,
      newtotalr: null,
      tableData: [],
      loading: false,
      dramaOptions: [
      ],
      pitcherOptions: [
      ]
    }
  },
  created() {
    this.menuList()
    this.ev_getDramaTypeList()
  },
  mounted() {},
  methods: {
    async ev_getDramaTypeList() {
      const { data } = await getDramaTypeList()
      console.log('resData', data)
      this.pitcherOptions = data.pitcher_type
      this.dramaOptions = data.type

      // 等 DOM 更新完成
      this.$nextTick(() => {
        this.isDataReady = true
        this.$refs.readingcreateview && this.$refs.readingcreateview.$forceUpdate()
      })
    },
    async menuList() {
      // 获取列表
      this.loading = true
      const data = await changduplayletindex(this.objr)
      console.log('data', data)
      this.loading = false
      this.tableData = data.data.list
      this.newtotalr = data.data.total
    },
    sraw() {
      this.objr.page = 1
      this.objr.page_size = 10
      this.menuList()
    },
    awered() {
      this.objr.page = 1
      this.objr.type = null
      this.objr.pitcher_type = null
      this.objr.name = ''
      this.menuList()
    },
    importbit() {
      this.dialogVisibleImport = true
      setTimeout(() => {
        this.$refs.readingimportview.send()
      }, 100)
    },
    addbit() {
      this.dialogVisible = true
      this.adtype = 1
      setTimeout(() => {
        this.$refs.readingcreateview.send(1)
      }, 100)
    },
    edit(item) {
      this.dialogVisible = true
      this.adtype = 2
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.readingcreateview.send(2, item)
      }, 100)
    },
    // 删除
    async deleteItem(row) {
      this.$confirm('是否确定删除该条信息吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        await weworkPhoneDelete({ id: row.id })
        this.menuList()
        this.$message({
          message: '删除成功',
          type: 'success'
        })
      })
    },
    // 分页
    fetchPageSizer(e) {
      this.objr.pageSize = e
      this.menuList()
    },
    fetchCurrentPager(e) {
      this.objr.page = e
      this.menuList()
    },
    updatawe() {
      this.dialogVisible = false
      this.menuList()
    },
    async updataweImport() {
      this.dialogVisibleImport = false
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.add_box {
  padding: 20px;
}
.search_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
